import styled from "styled-components";
import BREAKPOINTS from "../../Theme/Breakpoints";

export const Ribbon = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 0;
  transform: translateY(-50%);
  opacity: 1;

  img {
    display: flex;
    width: 100%;
    height: auto;
    object-fit: cover;
  }
`;

export const Wrapper = styled.div`
  padding: 4rem 2rem 3rem;
  background-image: linear-gradient(-20deg, #fbfcdb 0%, #e9defa 100%);
  position: relative;

  .heading {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
    position: relative;
    z-index: 1;

    h1 {
      margin: 0;
      font-family: "Poppins", sans-serif;
      font-weight: 600;
      font-size: 2rem;
    }

    svg {
      font-size: 2rem;
    }
  }
`;

export const CakeWrapper = styled.div`
  width: 600px;
  height: 520px;
  background-image: url("./cake.png");
  background-size: cover;
  background-position: center;
  position: relative;
  margin: 0 auto;
  margin-top: 6rem;
  filter: drop-shadow(0 10px 6px rgba(0, 0, 0, 0.4));

  ${BREAKPOINTS.MOBILE} {
    width: 100%;
    height: 300px;
    margin-top: 4rem;
  }
`;

export const Candle = styled.div`
  width: 16px;
  height: 90px;
  background-image: linear-gradient(45deg, #ee9ca7 0%, #ffdde1 100%);
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 3px;

  ${BREAKPOINTS.MOBILE} {
    width: 10px;
    height: 55px;
  }
`;

const flickerAnimation = `
  @keyframes flicker {
    0% { opacity: 1; transform: scale(1) translateX(0); }
    25% { opacity: 0.8; transform: scale(1.1) translateX(-2px); }
    50% { opacity: 1; transform: scale(1) translateX(3px); }
    75% { opacity: 0.9; transform: scale(1.05) translateX(-1px); }
    100% { opacity: 1; transform: scale(1) translateX(0); }
  }
`;

export const Flame = styled.div`
  width: 18px;
  height: 40px;
  background: linear-gradient(to top, #ff4500 0%, #ffc000 100%);
  border-radius: 50%;
  position: absolute;
  top: -42px;
  transform: translateX(-50%);
  animation: flicker 0.6s infinite;

  &.blown-out {
    background: transparent;
    animation: none;
  }

  ${flickerAnimation}

  ${BREAKPOINTS.MOBILE} {
    width: 12px;
    height: 24px;
    top: -26px;
  }
`;
